import { Injectable } from '@angular/core';
import 'rxjs/add/operator/map';
import { DatabaseProvider } from '../database/database';
import { SQLiteObject } from '@ionic-native/sqlite';

@Injectable()
export class FormaPgtoProvider {

  constructor(public dbProvider: DatabaseProvider) {

  }

  async insert(data) {
    this.dbProvider.getDB()
      .then((db: SQLiteObject) => {
        db.transaction(async (tx) => {
          let sql = 'insert into formaspgto(Fpg_Codigo, Fpg_Descricao, Fpg_FormulaPgto, Fpg_ContaDB) values (?, ?, ?, ?)';
          for (let val of data) {
            let formaPgto = new FormaPgto();
            formaPgto.codigo = val.Fpg_Codigo;
            formaPgto.nome = val.Fpg_Descricao;
            formaPgto.formula = val.Fpg_FormulaPgto;
            formaPgto.conta = val.Fpg_ContaDB;
            let params = [formaPgto.codigo, formaPgto.nome, formaPgto.formula, formaPgto.conta];

            await tx.executeSql(sql, params, (tx, resultSet) => {
              console.log('importou forma de pagamento');
            }, (err) => {
              console.log('erro:' + err);
            });

          }
        }).then();

      })
      .catch((e) => console.error(e));
  }

  public removeAll() {
    return this.dbProvider.getDB()
      .then((db: SQLiteObject) => {
        let sql = 'delete from formaspgto';
        let data = [];

        return db.executeSql(sql, data)
          .catch((e) => console.error(e));
      })
      .catch((e) => console.error(e));
  }

  public getAll() {
    return this.dbProvider.getDB()
      .then((db: SQLiteObject) => {
        let sql = 'SELECT * FROM formaspgto order by Fpg_Descricao';

        return db.executeSql(sql, [])
          .then((data: any) => {
            if (data.rows.length > 0) {
              let formasPgto: any[] = [];
              for (var i = 0; i < data.rows.length; i++) {
                var formaPgto = new FormaPgto();
                formaPgto.codigo = data.rows.item(i).Fpg_Codigo;
                formaPgto.nome = data.rows.item(i).Fpg_Descricao;
                formaPgto.formula = data.rows.item(i).Fpg_FormulaPgto;
                formaPgto.conta = data.rows.item(i).Fpg_ContaDB;
                formasPgto.push(formaPgto);
              }
              return formasPgto;
            } else {
              return [];
            }
          })
          .catch((e) => console.error(e));
      })
      .catch((e) => console.error(e));
  }

  public getOnlyPay() {
    return this.dbProvider.getDB()
      .then((db: SQLiteObject) => {
        let sql = "SELECT * FROM formaspgto where Fpg_FormulaPgto <> 'BOL' order by Fpg_Descricao";

        return db.executeSql(sql, [])
          .then((data: any) => {
            if (data.rows.length > 0) {
              let formasPgto: any[] = [];
              for (var i = 0; i < data.rows.length; i++) {
                var formaPgto = new FormaPgto();
                formaPgto.codigo = data.rows.item(i).Fpg_Codigo;
                formaPgto.nome = data.rows.item(i).Fpg_Descricao;
                formaPgto.formula = data.rows.item(i).Fpg_FormulaPgto;
                formaPgto.conta = data.rows.item(i).Fpg_ContaDB;
                formasPgto.push(formaPgto);
              }
              return formasPgto;
            } else {
              return [];
            }
          })
          .catch((e) => console.error(e));
      })
      .catch((e) => console.error(e));
  }

  public get(codigo) {
    return this.dbProvider.getDB()
      .then((db: SQLiteObject) => {
        let sql = 'SELECT * FROM formaspgto where Fpg_Codigo = ?';

        return db.executeSql(sql, [codigo])
          .then((data: any) => {
            var formaPgto = new FormaPgto();
            if (data.rows.length > 0) {
              formaPgto.codigo = data.rows.item(0).Fpg_Codigo;
              formaPgto.nome = data.rows.item(0).Fpg_Descricao;
              formaPgto.formula = data.rows.item(0).Fpg_FormulaPgto;
              formaPgto.conta = data.rows.item(0).Fpg_ContaDB;
            }
            return formaPgto;
          })
          .catch((e) => console.error(e));
      })
      .catch((e) => console.error(e));
  }
}

export class FormaPgto {
  codigo: number;
  nome: string;
  formula: string;
  conta: string
}



// WEBPACK FOOTER //
// ./src/providers/forma-pgto/forma-pgto.ts